import React, { useEffect, useState, useRef } from 'react';

/* ═══════════════════ Inline icons ═══════════════════ */

export const Icon = {
  ArrowRight: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  ),
  ArrowUp: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  ),
  Save: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Add: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  Edit: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  ),
  Trash: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  ),
  Close: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  ),
  Lock: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  Eye: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  EyeOff: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-10-7-10-7a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 10 7 10 7a18.6 18.6 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
      <path d="M14.12 14.12a3 3 0 0 1-4.24-4.24" />
    </svg>
  ),
  Phone: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72a2 2 0 0 1 1.72 2z" />
    </svg>
  ),
  ChevronDown: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="m6 9 6 6 6-6" />
    </svg>
  ),
  Upload: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Bookmark: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Book: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  Users: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  History: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  Card: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <rect x="2" y="6" width="20" height="14" rx="2" />
      <path d="M2 11h20" />
    </svg>
  ),
  Tag: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  List: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  User: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Check: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M5 12l5 5L20 7" />
    </svg>
  ),
  CheckCircle: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Logout: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  Menu: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  Pin: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M12 22s-8-7.5-8-13a8 8 0 1 1 16 0c0 5.5-8 13-8 13z" />
      <circle cx="12" cy="9" r="3" />
    </svg>
  ),
  Refresh: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  Info: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
  Calendar: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  ),
  Mail: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <path d="m22 6-10 7L2 6" />
    </svg>
  ),
  Eye2: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Switch: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M16 3h5v5" />
      <path d="M4 20l16.2-16.2" />
      <path d="M21 16v5h-5" />
      <path d="M15 15l6 6" />
      <path d="M4 4l5 5" />
    </svg>
  ),
};

/* ═══════════════════ AccountHeader - page header with kicker + title ═══════════════════ */

export function AccountHeader({ kicker, title, subtitle, action }) {
  return (
    <header className="relative isolate overflow-hidden rounded-2xl border border-amber/24 bg-surface-paper p-5 sm:p-6 mb-5">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-24 -right-24 h-56 w-56 rounded-full"
        style={{ background: 'radial-gradient(circle, rgba(251,191,36,0.14), transparent 70%)' }}
      />
      <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/30 to-transparent" />

      <div className="relative flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          {kicker && (
            <div className="mb-1.5 inline-flex items-center gap-1.5">
              <span aria-hidden className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber opacity-60" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-amber">{kicker}</span>
            </div>
          )}
          <h1 className="text-[20px] sm:text-[24px] font-bold leading-[1.2] tracking-[-0.02em] text-fg-primary">
            {title}
          </h1>
          <div aria-hidden className="mt-2 h-[2px] w-10 rounded-full bg-gradient-to-r from-amber to-amber/0" />
          {subtitle && (
            <p className="mt-2 text-[13px] leading-[1.55] text-fg-secondary max-w-[640px]">{subtitle}</p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </header>
  );
}

/* ═══════════════════ FormCard - wrapper for form pages ═══════════════════ */

export function FormCard({ children, onSubmit, className = '' }) {
  return (
    <form
      onSubmit={onSubmit}
      noValidate
      className={`relative rounded-2xl border border-amber/22 bg-surface-paper p-4 sm:p-5 md:p-6 ${className}`}
    >
      <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/45 to-transparent" />
      {children}
    </form>
  );
}

/* ═══════════════════ Field - text input with floating label ═══════════════════ */

export function Field({
  label,
  type = 'text',
  value,
  onChange,
  error,
  errorMsg,
  helper,
  required,
  autoComplete,
  inputMode,
  maxLength,
  placeholder,
  icon,
  rightSlot,
  multiline,
  rows = 5,
  disabled,
  readOnly,
}) {
  const showError = !!error;
  const Tag = multiline ? 'textarea' : 'input';

  return (
    <div className="w-full">
      {label && (
        <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
          {label}
          {required && <span className="ml-1 text-amber">*</span>}
        </label>
      )}
      <div
        className={`
          relative flex items-center gap-2 rounded-lg px-3
          ${multiline ? 'py-2.5 min-h-[120px] items-start' : 'h-11'}
          bg-surface-overlay/70
          border
          transition-[border-color,background-color,box-shadow] duration-200 ease-out-soft
          focus-within:bg-surface-overlay
          focus-within:shadow-[0_0_0_3px_rgba(251,191,36,0.22)]
          ${showError
            ? 'border-red-400/55 focus-within:border-red-400'
            : 'border-amber/22 hover:border-amber/55 focus-within:border-amber'
          }
          ${disabled ? 'opacity-60 pointer-events-none' : ''}
        `}
      >
        {icon && !multiline && (
          <span className={`shrink-0 ${showError ? 'text-red-400' : 'text-amber/80'}`}>{icon}</span>
        )}
        <Tag
          type={type}
          value={value ?? ''}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={inputMode}
          maxLength={maxLength}
          disabled={disabled}
          readOnly={readOnly}
          rows={multiline ? rows : undefined}
          className={`
            w-full bg-transparent
            text-[14px] font-medium text-fg-primary
            placeholder:text-fg-muted
            outline-none border-0 p-0
            ${multiline ? 'leading-[1.55] resize-y min-h-[100px]' : 'leading-none'}
          `}
        />
        {rightSlot && <div className="shrink-0 -mr-1">{rightSlot}</div>}
      </div>
      <div className="mt-1.5 min-h-[16px] text-[11px] leading-[1.4]">
        {showError ? (
          <span className="text-red-400">{errorMsg || 'Required'}</span>
        ) : helper ? (
          <span className="text-fg-tertiary">{helper}</span>
        ) : null}
      </div>
    </div>
  );
}

/* ═══════════════════ SelectField - custom amber-themed dropdown ═══════════════════
   Backwards-compatible API: still accepts <option> children. Internally we
   parse them into an options array and render a fully styled dropdown that
   matches the dark amber theme (no native OS dropdown chrome). */

function flattenOptions(children) {
  const out = [];
  React.Children.forEach(children, (child) => {
    if (!child) return;
    if (child.type === 'option') {
      out.push({
        value: child.props.value,
        label: typeof child.props.children === 'string'
          ? child.props.children
          : React.Children.toArray(child.props.children).join(''),
        disabled: !!child.props.disabled,
      });
    } else if (child.props && child.props.children) {
      out.push(...flattenOptions(child.props.children));
    }
  });
  return out;
}

export function SelectField({
  label,
  value,
  onChange,
  error,
  errorMsg,
  helper,
  required,
  children,
  disabled,
  placeholder = 'Select…',
}) {
  const showError = !!error;
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const wrapRef = useRef(null);
  const btnRef = useRef(null);

  const options = React.useMemo(() => flattenOptions(children), [children]);

  // Sync `active` index to currently selected option whenever the menu opens
  useEffect(() => {
    if (!open) return;
    const idx = options.findIndex((o) => o.value === value);
    setActive(idx >= 0 ? idx : 0);
  }, [open, options, value]);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') { setOpen(false); btnRef.current && btnRef.current.focus(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); setActive((i) => Math.min(i + 1, options.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((i) => Math.max(i - 1, 0)); }
      else if (e.key === 'Enter') { e.preventDefault(); pick(options[active]); }
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, active, options]);

  const pick = (opt) => {
    if (!opt || opt.disabled) return;
    onChange({ target: { value: opt.value } });
    setOpen(false);
    btnRef.current && btnRef.current.focus();
  };

  const selected = options.find((o) => o.value === value);
  const isPlaceholder = !selected || selected.value === '0' || selected.value === '';
  const display = selected ? selected.label : placeholder;

  return (
    <div ref={wrapRef} className="relative w-full">
      {label && (
        <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
          {label}
          {required && <span className="ml-1 text-amber">*</span>}
        </label>
      )}
      <button
        ref={btnRef}
        type="button"
        onClick={() => !disabled && setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        disabled={disabled}
        className={`
          relative flex h-11 w-full items-center gap-2 rounded-lg pl-3 pr-9 text-left
          bg-surface-overlay/70
          border
          transition-[border-color,background-color,box-shadow] duration-200 ease-out-soft
          ${showError
            ? 'border-red-400/55'
            : open
              ? 'border-amber bg-surface-overlay shadow-[0_0_0_3px_rgba(251,191,36,0.22)]'
              : 'border-amber/22 hover:border-amber/55'}
          ${disabled ? 'opacity-60 pointer-events-none' : ''}
        `}
      >
        <span className={`
          flex-1 truncate text-[14px] font-medium leading-none
          ${isPlaceholder ? 'text-fg-muted' : 'text-fg-primary'}
        `}>
          {display}
        </span>
        <span className={`
          pointer-events-none absolute right-3 top-1/2 -translate-y-1/2
          transition-[color,transform] duration-200
          ${open ? 'rotate-180 text-amber' : 'text-amber/80'}
        `}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4" aria-hidden>
            <path d="m6 9 6 6 6-6" />
          </svg>
        </span>
      </button>

      {open && (
        <div
          role="listbox"
          className="
            absolute left-0 right-0 top-full z-50 mt-2
            max-h-72 overflow-auto rounded-xl
            border border-amber/30 bg-surface-elevated
            shadow-dialog
            animate-[fadeIn_140ms_ease-out]
            py-1
          "
        >
          {options.map((opt, i) => {
            const isSel = opt.value === value;
            const isPlace = opt.value === '0' || opt.value === '';
            return (
              <button
                key={`${opt.value}-${i}`}
                type="button"
                role="option"
                aria-selected={isSel}
                disabled={opt.disabled}
                onMouseEnter={() => setActive(i)}
                onClick={() => pick(opt)}
                className={`
                  flex w-full items-center gap-2 px-3.5 py-2.5 text-left text-[13.5px]
                  transition-[background-color,color] duration-150 ease-out-soft
                  ${opt.disabled ? 'opacity-50 cursor-not-allowed' : ''}
                  ${isSel
                    ? 'bg-amber/14 text-amber font-semibold'
                    : i === active
                      ? 'bg-amber/8 text-fg-primary'
                      : isPlace
                        ? 'text-fg-muted'
                        : 'text-fg-secondary hover:bg-amber/8 hover:text-fg-primary'}
                `}
              >
                <span className="flex-1 truncate">{opt.label}</span>
                {isSel && (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="h-3.5 w-3.5 text-amber shrink-0" aria-hidden>
                    <path d="M5 12l5 5L20 7" />
                  </svg>
                )}
              </button>
            );
          })}
          {options.length === 0 && (
            <div className="px-3.5 py-2.5 text-[13px] text-fg-tertiary">No options.</div>
          )}
        </div>
      )}

      <div className="mt-1.5 min-h-[16px] text-[11px] leading-[1.4]">
        {showError ? (
          <span className="text-red-400">{errorMsg || 'Required'}</span>
        ) : helper ? (
          <span className="text-fg-tertiary">{helper}</span>
        ) : null}
      </div>
    </div>
  );
}

/* ═══════════════════ Switch - visibility toggle ═══════════════════ */

export function ToggleSwitch({ checked, onChange, label, hint }) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <span className="text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
          {label}
        </span>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={onChange}
        className={`
          group relative inline-flex h-11 items-center gap-3 rounded-lg
          border px-3
          transition-[background-color,border-color,box-shadow] duration-200 ease-out-soft
          ${checked
            ? 'border-amber/40 bg-amber/8 hover:bg-amber/12'
            : 'border-border-subtle bg-surface-overlay/70 hover:border-border-strong'
          }
        `}
      >
        <span
          className={`
            relative inline-flex h-5 w-9 shrink-0 items-center rounded-full
            transition-colors duration-200 ease-out-soft
            ${checked ? 'bg-amber' : 'bg-border-strong'}
          `}
        >
          <span
            className={`
              absolute top-0.5 inline-block h-4 w-4 rounded-full
              bg-ink shadow-[0_2px_4px_rgba(0,0,0,0.4)]
              transition-transform duration-200 ease-out-soft
              ${checked ? 'translate-x-[18px]' : 'translate-x-[2px]'}
            `}
          />
        </span>
        <span className="text-[13px] font-semibold text-fg-primary">
          {checked ? 'Visible to public' : 'Hidden from public'}
        </span>
      </button>
      {hint && <span className="text-[11px] text-fg-tertiary">{hint}</span>}
    </div>
  );
}

/* ═══════════════════ Modal - Esc to close, backdrop click ═══════════════════ */

export function Modal({ open, onClose, title, children, footer, size = 'md' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const widths = {
    xs: 'max-w-[360px]',
    sm: 'max-w-[440px]',
    md: 'max-w-[520px]',
    lg: 'max-w-[640px]',
  };

  return (
    <div
      className="fixed inset-0 z-[1300] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        aria-label="Close dialog"
        onClick={onClose}
        className="absolute inset-0 bg-black/70 backdrop-blur-md animate-[fadeIn_180ms_ease-out]"
      />
      <div
        className={`
          relative w-full ${widths[size] || widths.md}
          rounded-2xl border border-border-subtle bg-surface-paper
          shadow-dialog
          animate-[fadeIn_220ms_ease-out]
          max-h-[90vh] overflow-hidden flex flex-col
        `}
      >
        <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/30 to-transparent" />
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-border-subtle">
          <h2 className="text-[16px] font-bold tracking-[-0.01em] text-fg-primary">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="
              inline-flex h-8 w-8 items-center justify-center rounded-full
              text-fg-tertiary
              transition-[background-color,color] duration-200 ease-out-soft
              hover:bg-surface-overlay hover:text-fg-primary
            "
          >
            <Icon.Close className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4 text-[13px] leading-[1.6] text-fg-secondary">
          {children}
        </div>
        {footer && (
          <div className="flex items-center justify-end gap-2 border-t border-border-subtle px-5 py-3 bg-surface-overlay/40">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════ Buttons ═══════════════════ */

export function PrimaryButton({ children, type = 'button', loading, disabled, onClick, className = '', icon }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        group inline-flex h-11 items-center justify-center gap-2 rounded-lg px-5
        text-[12px] font-bold uppercase tracking-[0.1em]
        bg-amber text-ink
        transition-[background-color,box-shadow,transform] duration-200 ease-out-soft
        hover:bg-amber-light hover:shadow-[0_0_0_3px_rgba(251,191,36,0.28),0_8px_22px_-8px_rgba(251,191,36,0.5)]
        active:scale-[0.98]
        disabled:opacity-60 disabled:pointer-events-none
        ${className}
      `}
    >
      {loading ? (
        <svg viewBox="0 0 24 24" className="h-4 w-4 animate-spin" aria-hidden>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.5" fill="none" strokeDasharray="40 60" strokeLinecap="round" />
        </svg>
      ) : null}
      <span>{children}</span>
      {!loading && icon}
    </button>
  );
}

export function GhostButton({ children, type = 'button', onClick, className = '', icon, danger }) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`
        inline-flex h-10 items-center justify-center gap-1.5 rounded-lg px-4
        text-[12px] font-bold uppercase tracking-[0.08em]
        border
        transition-[background-color,border-color,color] duration-200 ease-out-soft
        ${danger
          ? 'border-red-400/40 text-red-400 hover:bg-red-400/10 hover:border-red-400/70'
          : 'border-border-subtle text-fg-secondary hover:bg-surface-overlay hover:text-fg-primary hover:border-border-strong'
        }
        ${className}
      `}
    >
      {icon}
      <span>{children}</span>
    </button>
  );
}

/* ═══════════════════ DetailRow - key/value row ═══════════════════ */

export function DetailRow({ label, value, children }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-1 sm:gap-3 py-3 border-b border-border-subtle last:border-b-0">
      <div className="text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary leading-[1.4]">
        {label}
      </div>
      <div className="text-[14px] font-medium text-fg-primary break-words">
        {value ?? children ?? <span className="text-fg-muted">-</span>}
      </div>
    </div>
  );
}

/* ═══════════════════ EmptyBlock - empty-state placeholder ═══════════════════ */

export function EmptyBlock({ icon, title, subtitle, action }) {
  return (
    <div className="rounded-2xl border border-border-subtle bg-surface-paper p-8 sm:p-10 text-center">
      {icon && (
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-amber/10 text-amber">
          {icon}
        </div>
      )}
      {title && <h3 className="text-[16px] font-bold text-fg-primary">{title}</h3>}
      {subtitle && <p className="mt-1.5 text-[13px] text-fg-secondary max-w-[420px] mx-auto">{subtitle}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}

/* ═══════════════════ SectionHead - small section title ═══════════════════ */

export function SectionHead({ kicker, title, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-3">
      <div className="min-w-0">
        {kicker && (
          <div className="mb-1 inline-flex items-center gap-1.5">
            <span aria-hidden className="inline-flex h-1 w-1 rounded-full bg-amber" />
            <span className="text-[9.5px] font-bold uppercase tracking-[0.16em] text-amber">{kicker}</span>
          </div>
        )}
        {title && (
          <h2 className="text-[15px] sm:text-[16px] font-bold tracking-[-0.01em] text-fg-primary">{title}</h2>
        )}
      </div>
      {action}
    </div>
  );
}
